import { render, staticRenderFns } from "./FolderNavigation.vue?vue&type=template&id=78c4fecc&scoped=true"
import script from "./FolderNavigation.vue?vue&type=script&lang=js"
export * from "./FolderNavigation.vue?vue&type=script&lang=js"
import style0 from "./FolderNavigation.vue?vue&type=style&index=0&id=78c4fecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c4fecc",
  null
  
)

export default component.exports